<br><br><div class="container-fluid">
    <div class="row form-container" [@inOutAnimation] [style.width.px]="formContainerWidth" *ngxPermissionsOnly="['evaluacionWeb']">
        <div class="form-content col-md-6" *ngIf="habilitado==1">
            <br>
            <div class="row">
                <div class="col-md-6">
                    <a *ngxPermissionsOnly="['nuevaEvaluacion']" class="btn-add" (click)="showDpiAlert()"><span class="img-add"><img src="../../assets/images/general/icon@2x.png" height="20px"></span> Agregar gestión</a>
                </div>
                <div class="col-md-6">
                  <a *ngxPermissionsOnly="['busquedaPorRangoDeFecha']" class="btn-add" (click)="showBusqueda()"><span class="img-add"><img src="../../assets/images/general/team.png" height="15px"></span> Consulta individual</a>
                </div>
                <div class="col-md-6">
                    <br>
                    <input class="form-control form-rounded" [(ngModel)]="term" placeholder="Buscar aquí">
                    <br>
                </div>
                <div class="col-md-6" *ngxPermissionsOnly="['busquedaPorRangoDeFecha']">
                  <br>
                  <select class="form-control form-rounded" [(ngModel)]="itemsPerPage">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  <br>
                </div>
                <div class="col-md-6" *ngxPermissionsOnly="['busquedaPorRangoDeFecha']">
                  <input class="form-control form-rounded"
                     type="date"
                     [min]="beginLimitDate"
                     [max]="maxDate"
                     [(ngModel)]="beginDate"
                      (ngModelChange)="loadDateFilters()">
                </div>
                <div class="col-md-6"  *ngxPermissionsOnly="['busquedaPorRangoDeFecha']">
                  <input class="form-control form-rounded" type="date"
                     [(ngModel)]="endDate"
                     [min]="beginLimitDate"
                     [max]="maxDate"
                     (ngModelChange)="loadDateFilters()">
                </div>
              <div class="col-md-6" *ngxPermissionsOnly="['busquedaPorRangoDeFecha']">
                <br>
                <select class="form-control form-rounded"
                        [(ngModel)]="colorFilter"
                        (ngModelChange)="loadDateFilters()">
                  <option value="VERDE">APROBADO</option>
                  <option value="ROJO">RECHAZADO</option>
                  <option value="AMARILLO">REVISIÓN</option>
                </select>
                <br>
              </div>
              <div class="col-md-6" *ngxPermissionsOnly="['busquedaPorRangoDeFecha']">
                <br>
                <select class="form-control form-rounded"
                        [(ngModel)]="filtercnSelected"
                        (ngModelChange)="loadDateFilters()">
                  <option value="0">TODOS LOS CNS</option>
                  <option value="1" *ngIf="usercn.nombrecn!=0">{{usercn.nombrecn}}</option>
                </select>
                <br>
              </div>
              <div class="col-md-12 ml-0 mr-0 p-0 mt-4">
                <pagination-controls
                  class="p-0 my-pagination"
                  previousLabel="Anterior"
                  nextLabel="Siguiente"
                  maxSize="6"
                  (pageChange)="p = $event"
                  (pageBoundsCorrection)="p = $event"
                ></pagination-controls>
              </div>
            </div>

            <div class="row" style="height: 700px; overflow-y: scroll;">
                <div class="col-md-12">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Nombre completo</th>
                                <th>DPI</th>
                                <th>Canal</th>
                             </tr>
                        </thead>
                        <tbody style="width: 100% !important;">
                                <tr *ngFor="let item of precalificaiones |
                                  filter:term |
                                  paginate: {
                                    itemsPerPage: itemsPerPage,
                                    currentPage: p
                                  }"
                                  class="state_{{item.estadoColorPrecalificacion}}"
                                    (click)="setGestion(item)" style="width: 100%  !important;">
                                    <td>{{item.noPrecalificacion}}</td>
                                    <td *ngIf="item.participante[0].tipoParticipante=='DEUDOR'">{{item.participante[0].nombreCompleto}}</td>
                                    <td *ngIf="item.participante[0].tipoParticipante=='DEUDOR'">{{item.participante[0].dpi}}</td>
                                    <td *ngIf="item.participante[0].tipoParticipante=='CODEUDOR'">{{item.participante[1].nombreCompleto}}</td>
                                    <td *ngIf="item.participante[0].tipoParticipante=='CODEUDOR'">{{item.participante[1].dpi}}</td>
                                    <td *ngIf="item.origen=='ACIETOWEB'||item.origen=='ACIERTOWEB'">WEB</td>
                                    <td *ngIf="item.origen=='AUTOGESTION'">AG</td>
                                    <td *ngIf="item.origen=='ACIETOAPP'">APP</td>
                                    <td *ngIf="item.origen=='N/A'">N/A</td>
                                </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="form-open">
            <div class="btn-open" (click)="OpenClose()">
                <span *ngIf="habilitado==1"><</span>
                <span *ngIf="habilitado==0">></span>
            </div>
        </div>

    </div>

</div>
